import React from 'react';
import classes from "../styles/style.module.css"

const HuubleCard = ({children}) => {
  return (
    <div className={classes.card}>{children}</div>
  )
}

export default HuubleCard